import { NullAstVisitor } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { PRIVILEDGES } from '../../../modules/service/roles.mockup';
import { PRIVILEDGESNEW } from '../../../modules/service/roles.mockup';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {
  falseAuth:boolean=false;

  appuser: any;
  menus:any = [];
  menusNew:any = [];
  user:any;
  userRoleLabel:any;
  bankName: string = '';
  bankLogoUrl: string = '';

  // Map legacy icon keys to Google Material Icon names
  iconMap: { [key: string]: string } = {
    'dashboard':         'dashboard',
    'purchasepolicy':    'add_shopping_cart',
    'renewpolicy':       'autorenew',
    'quote':             'request_quote',
    'mypolicies':        'verified_user',
    'icons8-print-100':  'description',
    'soldstickers':      'receipt_long',
    'notification':      'notifications',
    'commission':        'payments',
    'bankmanagement':    'account_balance',
    'usermanagement':    'people',
    'clientmanagement':  'person_search',
    'motorrisk':         'directions_car',
    'configurations':    'settings',
  };

  constructor(public router: Router, private service: DashboardService) {
    this.appuser=this.service.currentUser();

    if(this.appuser){
      const isSuperAdmin = this.appuser.role === 'ADMIN' &&
        (!this.appuser.bankName || this.appuser.bankName.trim() === '');

      this.menus = PRIVILEDGES.filter((menu) => {
        if (menu.role !== this.appuser.role) return false;
        // Hide Bank Management and Motor Risk for non-super admins
        if (this.appuser.role === 'ADMIN' && !isSuperAdmin) {
          if (menu.routerLink === '/bank-management' || menu.routerLink === '/motor-risk') {
            return false;
          }
        }
        return true;
      })


      this.menusNew = PRIVILEDGESNEW.filter((menus) => {
        return menus.role === this.appuser.role;
      })
    }
  }

  selectedIndex: number;
  selectedNumber: number;
  configurationsOpen = false;
  ngOnInit() {
    var role = this.appuser ? this.appuser.role : '';

    if (role === 'ADMIN') {
      this.user          = this.appuser.first_name || 'Admin';
      this.userRoleLabel = 'Administrator';
    } else if (role === 'agent') {
      this.user          = this.appuser.first_name || 'Agent';
      this.userRoleLabel = 'Intermediary';
    } else if (role === 'broker-admin') {
      this.user          = this.appuser.first_name || 'Broker';
      this.userRoleLabel = 'Broker Admin';
    } else if (role === 'broker-user') {
      this.user          = this.appuser.first_name || 'Broker';
      this.userRoleLabel = 'Broker User';
    } else if (role === 'client') {
      this.user          = this.appuser.first_name || 'Client';
      this.userRoleLabel = 'Client';
    } else {
      this.user          = this.appuser ? (this.appuser.first_name || 'User') : 'User';
      this.userRoleLabel = role || 'User';
    }

    // ── Bank info from session ──────────────────────────────────────────────
    this.bankName    = this.appuser ? (this.appuser.bankName    || '') : '';
    this.bankLogoUrl = this.appuser ? (this.appuser.bankLogoUrl || '') : '';

   var str_count = localStorage.getItem("tabStatusFirst");
   var str_count2 = localStorage.getItem("tabStatusSecond");

  //  console.log ( "one " + str_count )
  //  console.log(  "two" + str_count2 )


   var str_countInt = parseInt(str_count);
   var str_countInt2 = parseInt(str_count2);

  //  console.log ( "one " + str_countInt )
  //  console.log(  "two" + str_countInt2 )

   if ((str_count == null) && (str_count2 == null) ){

       this.selectedIndex = 0;
       //console.log ( "first" )
     }
     else  if ((str_countInt != 5) && (str_countInt2 == 5) ){

       this.selectedIndex = str_countInt;
       //console.log (  "second")
     }

     else {

       this.selectedNumber = str_countInt2;
       //console.log ( "third")
     }
  }


  routefn(routerLink:any){
    this.router.navigate([routerLink])
  }

  select(index: number, routerLink:any) {

    if(['/commission'].includes(routerLink))
    return;
    this.selectedIndex = index;

    this.router.navigate([routerLink])
    this.selectedNumber = null
    localStorage.setItem("tabStatusFirst", this.selectedIndex.toString());
    localStorage.setItem("tabStatusSecond", "5");
  }



  selectNotif(index: number, routerLink:any) {
    this.selectedIndex = null
    this.selectedNumber = index;

    //console.log('ahh'+ this.selectedNumber)

    this.router.navigate([routerLink])
    localStorage.setItem("tabStatusFirst", "5");
    localStorage.setItem("tabStatusSecond", this.selectedNumber.toString());
  }

  getMatIcon(iconKey: string): string {
    return this.iconMap[iconKey] || 'circle';
  }

  get configMenus(): any[] {
    return this.menus.filter((m: any) => m.icon === 'motorrisk');
  }

  toggleConfigurations() {
    this.configurationsOpen = !this.configurationsOpen;
  }

  selectConfig(routerLink: string) {
    this.selectedIndex = null;
    this.selectedNumber = null;
    this.router.navigate([routerLink]);
  }

}
